
import { Link, useParams } from 'react-router-dom';
import SEO from '../../components/SEO';

const festivalsData = {
  1: {
    id: 1,
    title: "Houston Mediterranean Festival: A Taste of Authentic Culture",
    description: "Experience authentic Mediterranean culture through food, music, dance, and traditions at Houston's beloved annual celebration.",
    date: "Friday-Saturday, October 24-25, 2025, 11am-10pm both days",
    location: "St. George Orthodox Church, 5311 Mercer St., Houston (West U)",
    duration: "2 days",
    category: "Cultural",
    admission: "$5 entry (tickets online & at gate)",
    parking: "Free off-site parking available; rideshare recommended",
    bestTime: "Check site map before you go; arrive early for best parking",
    image: "https://public.readdy.ai/ai/img_res/d66babfe6b0c71f726eeac10cec02797.jpg",
    highlights: [
      "Traditional kabobs, falafel, gyro & za'atar",
      "Sweet baklava & Mediterranean desserts", 
      "Kids zone & church tours",
      "Market, hookah, beer & wine"
    ],
    schedule: [
      {
        activity: "Festival Opening & Traditional Welcome",
        description: "Traditional ceremony to open the festival, featuring community leaders and cultural presentations."
      },
      {
        activity: "Authentic Mediterranean Food Pavilions",
        description: "Sample traditional dishes including kabobs, falafel, gyro, and za'atar prepared by community families using generations-old recipes."
      },
      {
        activity: "Cultural Marketplace & Shopping",
        description: "Browse handmade crafts, traditional clothing, religious items, and imported goods from Mediterranean countries."
      },
      {
        activity: "Kids Zone Activities",
        description: "Children can participate in Mediterranean-themed games, crafts, and cultural activities designed for families."
      },
      {
        activity: "Church Tours & Cultural Education",
        description: "Guided tours of St. George Orthodox Church with insights into Orthodox traditions and Mediterranean heritage."
      },
      {
        activity: "Evening Entertainment",
        description: "Live music, traditional performances, and community celebration with hookah, beer, and wine available."
      }
    ],
    culturalContext: "The Houston Mediterranean Festival represents the strong Mediterranean communities that settled in Houston's Near Northside and Montrose areas in the early 1900s. Greek families and Lebanese merchants established businesses that became Houston institutions. Today, the festival serves as a bridge between generations, allowing immigrant families to share their heritage while welcoming new Houstonians into their traditions. The authentic recipes, traditional dances, and cultural exhibits preserve customs that might otherwise be lost in America's melting pot.",
    foodGuide: [
      {
        dish: "Kabobs",
        description: "Grilled meat skewers with Mediterranean spices and seasonings"
      },
      {
        dish: "Falafel",
        description: "Crispy chickpea fritters served with tahini sauce and fresh vegetables"
      },
      {
        dish: "Gyro",
        description: "Traditional Greek pita wraps with seasoned meat, tzatziki, and fresh vegetables"
      },
      {
        dish: "Za'atar",
        description: "Middle Eastern herb blend served with olive oil and fresh bread"
      },
      {
        dish: "Baklava",
        description: "Layers of phyllo pastry with nuts and honey syrup - a festival favorite"
      }
    ]
  },
  2: {
    id: 2,
    title: "43rd Annual Galveston Island Oktoberfest: German Heritage Meets Coastal Charm",
    description: "Celebrate German heritage with authentic beer, bratwurst, live music, and coastal charm at Galveston's 43rd annual Oktoberfest.",
    date: "Friday-Saturday, October 24-25, 2025 (times vary)",
    location: "First Lutheran Church, 24th & Winnie, Historic Downtown Galveston",
    duration: "2 days",
    category: "Cultural",
    admission: "Free admission (food/drink for purchase)",
    parking: "Downtown Galveston parking available",
    bestTime: "Bring card/tap payment for speed at upgraded POS booths",
    image: "https://readdy.ai/api/search-image?query=Galveston%20Oktoberfest%20celebration%20with%20people%20in%20traditional%20German%20clothing%2C%20beer%20gardens%20by%20the%20ocean%2C%20live%20polka%20music%2C%20festive%20coastal%20atmosphere%2C%20authentic%20German%20festival%20vibes&width=800&height=500&seq=galveston-oktoberfest-detail&orientation=landscape",
    highlights: [
      "Two stages of live music & dancing",
      "German dinner Friday & Saturday",
      "Kids activities & vendors in The Lyceum",
      "Steinholding competitions"
    ],
    schedule: [
      {
        activity: "Oktoberfest Opening Ceremony",
        description: "Traditional German opening with ceremonial activities and community celebration."
      },
      {
        activity: "Two-Stage Entertainment",
        description: "Live music and dancing performances on two stages featuring polka bands and German folk music."
      },
      {
        activity: "German Dinner Service",
        description: "Authentic German dinner available both Friday and Saturday evenings with traditional dishes."
      },
      {
        activity: "Kids Activities Zone",
        description: "Family-friendly activities and games designed for children in The Lyceum venue."
      },
      {
        activity: "Vendor Market in The Lyceum",
        description: "Browse local vendors and German-themed merchandise in the historic Lyceum building."
      },
      {
        activity: "Steinholding Competition",
        description: "Traditional German beer stein holding contest - test your strength and endurance!"
      }
    ],
    culturalContext: "Galveston's Oktoberfest celebrates the island's rich German heritage dating back to the 1840s when German immigrants first arrived seeking new opportunities. These settlers established breweries, bakeries, and businesses that shaped Galveston's character. Today's festival combines authentic German customs with Galveston's unique coastal culture, creating a celebration that honors both heritage and place. The event serves as an educational experience, teaching younger generations about the German contributions to Texas culture while providing a fun, family-friendly atmosphere.",
    foodGuide: [
      {
        dish: "German Dinner",
        description: "Traditional German meal served Friday and Saturday evenings"
      },
      {
        dish: "Bratwurst",
        description: "Traditional German sausages grilled to perfection"
      },
      {
        dish: "German Beer",
        description: "Authentic German beers and local German-style brews"
      },
      {
        dish: "Soft Pretzels",
        description: "Large, warm pretzels with coarse salt and beer cheese"
      },
      {
        dish: "German Pastries",
        description: "Traditional German sweets and baked goods"
      }
    ]
  },
  3: {
    id: 3,
    title: "12th Annual Magnolia Park Día de los Muertos Festival: Celebrating Life and Legacy",
    description: "Honor life and legacy through vibrant celebrations with parade, altars, and cultural performances in Houston's East End.",
    date: "Saturday, October 25, 2025 — Parade 9am; Festival 10am-4pm",
    location: "Hidalgo Park, 7000 Ave Q, Houston (East End)",
    duration: "1 day",
    category: "Cultural",
    admission: "Free",
    parking: "Street parking fills early - arrive by 8:30-8:45am for best spots",
    bestTime: "Arrive early for parade at 9am; street parking fills quickly",
    image: "https://readdy.ai/api/search-image?query=Houston%20D%C3%ADa%20de%20los%20Muertos%20festival%20with%20colorful%20altars%2C%20families%20creating%20sugar%20skull%20art%2C%20traditional%20Mexican%20decorations%2C%20vibrant%20cultural%20celebration%2C%20marigold%20flowers%20and%20candles&width=800&height=500&seq=dia-muertos-detail&orientation=landscape",
    highlights: [
      "Morning parade at 9am",
      "Traditional altars & cultural performances",
      "Live music & authentic food",
      "Kids activities & artisan market"
    ],
    schedule: [
      {
        activity: "Community Parade",
        description: "Traditional Día de los Muertos parade begins at 9am featuring colorful floats, traditional costumes, and community participation."
      },
      {
        activity: "Traditional Altar Displays",
        description: "Community-created ofrendas (altars) honoring deceased family members and cultural figures throughout the park."
      },
      {
        activity: "Cultural Performances",
        description: "Live music, dance performances, and cultural presentations celebrating Mexican heritage and traditions."
      },
      {
        activity: "Artisan Market",
        description: "Local vendors selling traditional crafts, artwork, and handmade items related to Día de los Muertos."
      },
      {
        activity: "Kids Activities Zone",
        description: "Family-friendly activities including face painting, crafts, and educational programs about the holiday's meaning."
      },
      {
        activity: "Authentic Food Vendors",
        description: "Traditional Mexican food and beverages available from local vendors and community groups."
      }
    ],
    culturalContext: "The Magnolia Park Día de los Muertos Festival reflects Houston's deep Mexican roots, particularly in the East End where Mexican families have lived for generations. This celebration is not about mourning death but celebrating the continuation of life and memory. Houston's Mexican-American community has adapted the tradition to urban life while maintaining its spiritual significance. The festival serves as a bridge between indigenous Mexican traditions and contemporary American life, teaching children about their heritage while creating new traditions in Houston's diverse cultural landscape.",
    foodGuide: [
      {
        dish: "Pan de Muerto",
        description: "Traditional sweet bread decorated with bone-shaped pieces, flavored with orange and anise"
      },
      {
        dish: "Tamales",
        description: "Corn masa filled with meat or cheese, wrapped in corn husks and steamed"
      },
      {
        dish: "Elote",
        description: "Mexican street corn with mayo, chili powder, and lime"
      },
      {
        dish: "Atole",
        description: "Warm, thick drink made from corn masa, flavored with cinnamon and vanilla"
      },
      {
        dish: "Traditional Mexican Sweets",
        description: "Various traditional candies and desserts associated with the holiday"
      }
    ]
  },
  4: {
    id: 4,
    title: "Halloween in the Hangar: Aviation Meets Spooky Science",
    description: "Combine aviation history with Halloween fun in this unique family-friendly celebration featuring hands-on activities.",
    date: "Saturday, October 25, 2025, 10am-1pm (members get in at 9am)",
    location: "Lone Star Flight Museum, Ellington Airport",
    duration: "3 hours",
    category: "Family",
    admission: "Included with museum admission; kids 10 & under in costume get in free (10am-1pm)",
    parking: "Free museum parking",
    bestTime: "Hit the 10-11am window for shorter lines; photo ops best near hangar doors",
    image: "https://readdy.ai/api/search-image?query=Lone%20Star%20Flight%20Museum%20Halloween%20event%20with%20families%20in%20costumes%20exploring%20vintage%20aircraft%2C%20children%20participating%20in%20aviation-themed%20activities%2C%20festive%20hangar%20atmosphere%20with%20Halloween%20decorations&width=800&height=500&seq=halloween-hangar-detail&orientation=landscape",
    highlights: [
      "Trick-or-treating among aircraft",
      "Pumpkin parachute drop",
      "Catapult challenge & bat gliders",
      "Story time & photo ops"
    ],
    schedule: [
      {
        activity: "Early Member Access",
        description: "Museum members get special early access starting at 9am for shorter lines and better photo opportunities."
      },
      {
        activity: "Trick-or-Treating Among Aircraft",
        description: "Children in costumes can trick-or-treat throughout the museum's historic aircraft displays."
      },
      {
        activity: "Pumpkin Parachute Drop",
        description: "Watch pumpkins drop with parachutes in this fun demonstration of gravity and air resistance."
      },
      {
        activity: "Catapult Challenge",
        description: "Kids can participate in building and testing catapults, learning about physics and engineering."
      },
      {
        activity: "Bat Glider Workshop",
        description: "Create and test bat-shaped gliders while learning about flight principles and aerodynamics."
      },
      {
        activity: "Aviation Story Time",
        description: "Halloween-themed stories about aviation history and spooky tales from the skies."
      }
    ],
    culturalContext: "The Lone Star Flight Museum's Halloween event represents Houston's unique position in aviation and space exploration history. Located near NASA's Johnson Space Center, Houston has been central to American aviation advancement since the 1960s. This event combines the city's aerospace heritage with family-friendly Halloween fun, creating an educational experience that inspires the next generation of pilots, engineers, and astronauts. By making aviation history accessible through Halloween activities, the event continues Houston's tradition of making complex science understandable and exciting for children.",
    foodGuide: [
      {
        dish: "Museum Café Treats",
        description: "Halloween-themed snacks and beverages available at the museum café"
      },
      {
        dish: "Pilot's Lunch Box",
        description: "Kid-friendly meal options served in aviation-themed packaging"
      },
      {
        dish: "Astronaut Ice Cream",
        description: "Freeze-dried ice cream just like astronauts eat in space"
      },
      {
        dish: "Aviation Snacks",
        description: "Themed snacks and treats available throughout the event"
      },
      {
        dish: "Hot Chocolate",
        description: "Warm beverages perfect for the October weather"
      }
    ]
  },
  5: {
    id: 5,
    title: "6th Annual Hike, Bike & Fright Fest: Eco-Friendly Halloween Adventure",
    description: "Experience eco-friendly Halloween fun with trick-or-treat trail, plant market, and sustainable celebration activities.",
    date: "Saturday, October 25, 2025, Noon-6pm",
    location: "M-K-T Heights Trail, 600 N Shepherd Dr.",
    duration: "6 hours",
    category: "Outdoor",
    admission: "Free",
    parking: "Street parking along trail",
    bestTime: "Bring a small tote for treats; crowds swell 2-4pm",
    image: "https://readdy.ai/api/search-image?query=Houston%20Heights%20trail%20Halloween%20bike%20event%20with%20families%20in%20costumes%20riding%20bikes%20on%20tree-lined%20paths%2C%20eco-friendly%20Halloween%20decorations%2C%20outdoor%20community%20celebration%20atmosphere&width=800&height=500&seq=bike-fright-fest-detail&orientation=landscape",
    highlights: [
      "Trick-or-treat trail",
      "HalloGreen plant market",
      "Kid & pet-friendly activities",
      "DJs & shopping deals"
    ],
    schedule: [
      {
        activity: "Trick-or-Treat Trail Opening",
        description: "The main trick-or-treat trail opens with stations throughout the M-K-T Heights area."
      },
      {
        activity: "HalloGreen Plant Market",
        description: "Special plant market featuring Halloween-themed plants, succulents, and eco-friendly gardening supplies."
      },
      {
        activity: "Kid & Pet-Friendly Activities",
        description: "Family and pet-friendly games, activities, and entertainment designed for all ages."
      },
      {
        activity: "DJ Entertainment",
        description: "Live DJ sets providing music and entertainment throughout the trail area."
      },
      {
        activity: "Local Business Shopping Deals",
        description: "Special Halloween deals and promotions from local Heights businesses along the trail."
      },
      {
        activity: "Community Giveaways",
        description: "Various giveaways and prizes from local sponsors and community partners."
      }
    ],
    culturalContext: "The M-K-T Heights Trail follows the route of the historic Missouri-Kansas-Texas Railroad that connected Houston to the rest of Texas in the early 1900s. This Halloween event celebrates both the trail's history and Houston's growing environmental consciousness. The Heights neighborhood has become a model for sustainable urban living, with residents embracing bike commuting, urban gardening, and eco-friendly practices. By combining Halloween celebration with environmental education, the event teaches children about sustainability while honoring the neighborhood's transportation heritage.",
    foodGuide: [
      {
        dish: "Local Food Trucks",
        description: "Various food trucks offering Halloween-themed treats and healthy options"
      },
      {
        dish: "Organic Treats",
        description: "Eco-friendly and organic Halloween candy and snacks"
      },
      {
        dish: "Seasonal Beverages",
        description: "Pumpkin spice drinks and other fall-themed beverages"
      },
      {
        dish: "Healthy Trail Snacks",
        description: "Energy bars, trail mix, and other healthy snacks for active families"
      },
      {
        dish: "Local Coffee",
        description: "Coffee and warm beverages from local Heights coffee shops"
      }
    ]
  },
  6: {
    id: 6,
    title: "Boofest Kingwood: Suburban Halloween Magic",
    description: "Discover suburban Houston's Halloween magic through this beloved community celebration showcasing local pride and family fun.",
    date: "Saturday, October 25, 2025, 4pm-9pm",
    location: "Kingwood Town Center Park, 8 N Main St.",
    duration: "5 hours",
    category: "Community",
    admission: "Free",
    parking: "Parking easier on north side; bring cash for food vendors",
    bestTime: "Arrive early for best parking; bring cash for vendors",
    image: "https://readdy.ai/api/search-image?query=Kingwood%20Houston%20suburban%20Halloween%20festival%20with%20families%20in%20costumes%2C%20community%20parade%2C%20local%20vendors%2C%20tree-lined%20neighborhood%20celebration%2C%20family-friendly%20Halloween%20atmosphere&width=800&height=500&seq=boofest-kingwood-detail&orientation=landscape",
    highlights: [
      "Trick-or-treating stations",
      "Mini pumpkin patch",
      "Free train rides",
      "Live music & costume fun"
    ],
    schedule: [
      {
        activity: "Festival Opening & Setup",
        description: "Community volunteers set up trick-or-treating stations and activity areas throughout the park."
      },
      {
        activity: "Trick-or-Treating Stations",
        description: "Multiple trick-or-treating stations operated by local businesses and community groups."
      },
      {
        activity: "Mini Pumpkin Patch",
        description: "Children can select pumpkins from the mini pumpkin patch and participate in pumpkin-themed activities."
      },
      {
        activity: "Free Train Rides",
        description: "Complimentary train rides around the park area for children and families."
      },
      {
        activity: "Live Music Entertainment",
        description: "Local musicians and bands provide live entertainment throughout the evening."
      },
      {
        activity: "Costume Showcase",
        description: "Informal costume showcase where families can show off their Halloween creativity."
      }
    ],
    culturalContext: "Kingwood represents Houston's suburban expansion in the 1970s and 1980s, when master-planned communities became the model for family-friendly living. Boofest showcases the strong community spirit that defines suburban Houston, where neighbors know each other and work together to create safe, fun environments for children. Kingwood's tree-lined streets and family-oriented culture make it an ideal setting for traditional Halloween celebrations. The festival demonstrates how newer Houston communities maintain small-town values while embracing the diversity and opportunities of a major metropolitan area.",
    foodGuide: [
      {
        dish: "Local Food Vendors",
        description: "Various local food vendors offering Halloween treats and family favorites (cash recommended)"
      },
      {
        dish: "Carnival Treats",
        description: "Classic carnival foods like funnel cakes, cotton candy, and caramel apples"
      },
      {
        dish: "BBQ & Comfort Food",
        description: "Traditional Texas BBQ and comfort food from local vendors"
      },
      {
        dish: "Hot Chocolate & Cider",
        description: "Warm beverages perfect for the October evening weather"
      },
      {
        dish: "Halloween Candy",
        description: "Traditional trick-or-treat candy available at various stations"
      }
    ]
  },
  7: {
    id: 7,
    title: "Scream on the Green: Downtown's Ultimate Halloween Party",
    description: "Join Houston's biggest costume party in the heart of downtown, featuring outdoor movie screening and urban Halloween festivities.",
    date: "Saturday, October 25, 2025, 6pm-9pm (movie at 7pm)",
    location: "Discovery Green, 1500 McKinney St., Downtown",
    duration: "3 hours",
    category: "Urban",
    admission: "Free (pre-registration required for costume contest)",
    parking: "Paid downtown parking available",
    bestTime: "Bring blanket or low chairs; arrive by 6pm for costume contest - slots go fast",
    image: "https://readdy.ai/api/search-image?query=Discovery%20Green%20Houston%20downtown%20Halloween%20event%20with%20large%20outdoor%20movie%20screen%2C%20people%20in%20costumes%20on%20grass%20with%20city%20skyline%20background%2C%20urban%20festival%20atmosphere%20at%20night&width=800&height=500&seq=scream-green-detail&orientation=landscape",
    highlights: [
      "Costume contest (pre-registration required)",
      "Living sculptures & palm readers",
      "Games & entertainment",
      "Beetlejuice Beetlejuice movie screening"
    ],
    schedule: [
      {
        activity: "Costume Contest Registration & Judging",
        description: "Pre-registered participants showcase their costumes on stage with the downtown skyline backdrop."
      },
      {
        activity: "Living Sculptures & Interactive Art",
        description: "Professional performers create living sculptures and interactive art installations throughout the park."
      },
      {
        activity: "Palm Readers & Psychics",
        description: "Professional palm readers and psychics provide entertainment and mystical experiences."
      },
      {
        activity: "Halloween Games & Activities",
        description: "Various Halloween-themed games and activities for all ages before the movie begins."
      },
      {
        activity: "Beetlejuice Beetlejuice Movie Screening",
        description: "Outdoor screening of Beetlejuice Beetlejuice (2024, PG-13) on the giant outdoor screen at 7pm."
      },
      {
        activity: "Post-Movie Celebration",
        description: "Continued entertainment and activities after the movie screening ends."
      }
    ],
    culturalContext: "Discovery Green represents Houston's commitment to creating vibrant urban spaces that bring diverse communities together. Opened in 2008, the park transformed a neglected downtown area into Houston's premier gathering place. Scream on the Green showcases how modern Houston embraces both its urban sophistication and its love of community celebration. The event attracts young professionals, families, and visitors from across the metropolitan area, creating a uniquely Houston experience that combines big-city energy with Texas hospitality.",
    foodGuide: [
      {
        dish: "Food Trucks",
        description: "Various gourmet food trucks offering elevated comfort food and creative cuisine"
      },
      {
        dish: "Movie Snacks",
        description: "Traditional movie theater snacks like popcorn and candy"
      },
      {
        dish: "Craft Beverages",
        description: "Local craft beer and specialty beverages (where permitted)"
      },
      {
        dish: "Halloween Treats",
        description: "Seasonal treats and Halloween-themed snacks from local vendors"
      },
      {
        dish: "Downtown Dining",
        description: "Nearby downtown restaurants offer pre-event dining options"
      }
    ]
  },
  8: {
    id: 8,
    title: "Diwali Lights! Festival: Houston's Festival of Lights",
    description: "Celebrate the Festival of Lights with traditional performances, authentic cuisine, and cultural education highlighting Houston's diversity.",
    date: "Sunday, October 26, 2025, 3pm-7pm (Ramayana performance at ~5pm; ticketed)",
    location: "Asia Society Texas Center, 1370 Southmore Blvd.",
    duration: "4 hours",
    category: "Cultural",
    admission: "Free with RSVP (performance tickets extra; often sell out)",
    parking: "Museum district street parking is tight",
    bestTime: "GA RSVPs hit capacity - grab performance tickets early",
    image: "https://readdy.ai/api/search-image?query=Houston%20Diwali%20festival%20celebration%20with%20families%20lighting%20traditional%20oil%20lamps%2C%20colorful%20Indian%20decorations%2C%20cultural%20dance%20performances%2C%20festive%20lights%20and%20rangoli%20patterns&width=800&height=500&seq=diwali-festival-detail&orientation=landscape",
    highlights: [
      "Family festival of lights",
      "Crafts, food & fashion",
      "Music & dance performances",
      "Ramayana performance (ticketed)"
    ],
    schedule: [
      {
        activity: "Festival Opening & Welcome",
        description: "Traditional opening ceremony welcoming families to the Festival of Lights celebration."
      },
      {
        activity: "Craft Workshops & Activities",
        description: "Hands-on workshops teaching traditional Indian crafts, rangoli art, and Diwali decorations."
      },
      {
        activity: "Fashion & Cultural Displays",
        description: "Traditional Indian fashion shows and cultural exhibits showcasing regional diversity."
      },
      {
        activity: "Music & Dance Performances",
        description: "Live performances of classical Indian music and dance by local artists and cultural groups."
      },
      {
        activity: "Ramayana Performance",
        description: "Special ticketed performance of the Ramayana epic at approximately 5pm (tickets often sell out)."
      },
      {
        activity: "Community Feast & Celebration",
        description: "Traditional vegetarian Diwali feast with authentic Indian cuisine and community celebration."
      }
    ],
    culturalContext: "Houston's Diwali celebration reflects the city's significant South Asian population, which has grown dramatically since the 1960s. The Asia Society Texas Center serves as a cultural bridge between Houston's diverse Asian communities and the broader population. Diwali, the Festival of Lights, celebrates the victory of light over darkness and good over evil. In Houston, this ancient tradition takes on new meaning as immigrant families share their heritage with neighbors from around the world. The festival demonstrates how Houston's cultural institutions help preserve traditions while fostering cross-cultural understanding.",
    foodGuide: [
      {
        dish: "Traditional Indian Sweets",
        description: "Authentic Diwali sweets including gulab jamun, barfi, and laddu"
      },
      {
        dish: "Samosas & Savory Snacks",
        description: "Crispy pastries and traditional savory snacks with chutneys"
      },
      {
        dish: "Vegetarian Feast",
        description: "Traditional vegetarian dishes representing various regions of India"
      },
      {
        dish: "Masala Chai",
        description: "Traditional spiced tea served hot with milk and sugar"
      },
      {
        dish: "Festival Treats",
        description: "Special Diwali treats and seasonal specialties"
      }
    ]
  },
  9: {
    id: 9,
    title: "Sugar Land Día de los Muertos Celebration: Suburban Cultural Festival",
    description: "Experience authentic Mexican traditions with mariachi music, ballet folklórico, and cultural celebrations in Sugar Land.",
    date: "Saturday, October 25, 2025, Noon-5pm",
    location: "Sugar Land Town Square, 2700 Town Center Blvd N",
    duration: "5 hours",
    category: "Urban Cultural",
    admission: "Free",
    parking: "Park in City Walk garages; catch early performances before crowds",
    bestTime: "Arrive early for parking; catch performances before plaza gets crowded",
    image: "https://readdy.ai/api/search-image?query=Sugar%20Land%20Town%20Square%20D%C3%ADa%20de%20los%20Muertos%20celebration%20with%20mariachi%20performers%2C%20colorful%20Mexican%20decorations%2C%20families%20celebrating%20cultural%20traditions%2C%20outdoor%20festival%20atmosphere&width=800&height=500&seq=sugar-land-muertos-detail&orientation=landscape",
    highlights: [
      "Mariachi & ballet folklórico",
      "Aztec dancers performances",
      "Artisan market & authentic cuisine",
      "Family-friendly activities"
    ],
    schedule: [
      {
        activity: "Festival Opening & Mariachi Welcome",
        description: "Traditional mariachi music welcomes families to the Sugar Land Día de los Muertos celebration."
      },
      {
        activity: "Ballet Folklórico Performances",
        description: "Traditional Mexican folk dance performances showcasing regional dances and colorful costumes."
      },
      {
        activity: "Aztec Dancers Cultural Presentation",
        description: "Authentic Aztec dance performances connecting modern celebrations to ancient traditions."
      },
      {
        activity: "Artisan Market & Cultural Vendors",
        description: "Local artisans selling traditional crafts, artwork, and handmade items celebrating Mexican culture."
      },
      {
        activity: "Authentic Cuisine & Food Vendors",
        description: "Traditional Mexican food vendors offering authentic dishes and seasonal specialties."
      },
      {
        activity: "Family Activities & Cultural Education",
        description: "Kids activities, face painting, and educational programs about Día de los Muertos traditions."
      }
    ],
    culturalContext: "Sugar Land's Día de los Muertos celebration represents the growing Mexican-American community in Houston's southwestern suburbs. As Sugar Land has become increasingly diverse, events like this help preserve and share Mexican cultural traditions with the broader community. The celebration takes place in the heart of Sugar Land's modern town center, creating a bridge between traditional Mexican customs and contemporary suburban life. This festival demonstrates how Houston's suburban communities embrace cultural diversity while maintaining their family-friendly atmosphere.",
    foodGuide: [
      {
        dish: "Traditional Mexican Cuisine",
        description: "Authentic Mexican dishes prepared by local vendors and community groups"
      },
      {
        dish: "Pan de Muerto",
        description: "Traditional Day of the Dead bread with orange and anise flavoring"
      },
      {
        dish: "Elote & Mexican Street Food",
        description: "Mexican street corn and other traditional street food favorites"
      },
      {
        dish: "Agua Fresca",
        description: "Refreshing fruit drinks in traditional flavors like horchata and tamarind"
      },
      {
        dish: "Traditional Sweets",
        description: "Mexican candies and desserts associated with Día de los Muertos"
      }
    ]
  },
  10: {
    id: 10,
    title: "Una Noche! Día de los Muertos: Halloween Night Downtown Celebration",
    description: "Experience how Houston honors Mexican traditions on Halloween night with this downtown celebration of life and memory.",
    date: "Friday, October 31, 2025 (Halloween), 7pm-10pm",
    location: "Market Square Park, 301 Milam St., Downtown",
    duration: "3 hours",
    category: "Urban Cultural",
    admission: "Free (registration link available)",
    parking: "Consider rideshare to avoid downtown parking challenges",
    bestTime: "Add your loved one's photo at the ofrenda - printing is free but lines form",
    image: "https://readdy.ai/api/search-image?query=Market%20Square%20Park%20Houston%20downtown%20D%C3%ADa%20de%20los%20Muertos%20celebration%20with%20traditional%20altars%2C%20urban%20setting%20with%20skyscrapers%2C%20families%20celebrating%20Mexican%20culture%2C%20colorful%20decorations%20and%20marigolds&width=800&height=500&seq=market-square-muertos-detail&orientation=landscape",
    highlights: [
      "Evening mariachi & ballet folklórico",
      "Free face painting & arts workshops",
      "Community ofrenda with free photo printing",
      "Live music performances"
    ],
    schedule: [
      {
        activity: "Evening Festival Opening",
        description: "Traditional opening ceremony for this special Halloween night Día de los Muertos celebration."
      },
      {
        activity: "Mariachi & Ballet Folklórico Performances",
        description: "Live mariachi music and traditional Mexican folk dance performances under the downtown lights."
      },
      {
        activity: "Free Face Painting & Arts Workshops",
        description: "Professional artists provide free face painting and lead arts workshops for families."
      },
      {
        activity: "Community Ofrenda & Photo Printing",
        description: "Add your loved one's photo to the community altar - free photo printing available (lines may form)."
      },
      {
        activity: "Live Music & Cultural Performances",
        description: "Continuous live music and cultural performances celebrating Mexican heritage."
      },
      {
        activity: "Halloween Night Celebration",
        description: "Special Halloween night atmosphere combining Día de los Muertos traditions with Halloween festivities."
      }
    ],
    culturalContext: "Market Square Park's Halloween night Día de los Muertos celebration represents the intersection of Houston's Mexican heritage with its modern urban identity. The park sits on land that was once Houston's original marketplace, where Mexican traders sold goods in the 1800s. This unique Halloween night celebration honors both this commercial history and the spiritual traditions of Día de los Muertos. The downtown setting creates a special atmosphere where ancient traditions unfold against a backdrop of modern skyscrapers, symbolizing how Mexican culture continues to evolve and thrive in contemporary Houston.",
    foodGuide: [
      {
        dish: "Evening Food Vendors",
        description: "Traditional Mexican food vendors offering dinner options and seasonal treats"
      },
      {
        dish: "Pan de Muerto",
        description: "Traditional Day of the Dead bread perfect for the evening celebration"
      },
      {
        dish: "Hot Chocolate & Warm Beverages",
        description: "Traditional Mexican hot chocolate and warm drinks for the October evening"
      },
      {
        dish: "Street Food Favorites",
        description: "Mexican street food including elote, churros, and other handheld favorites"
      },
      {
        dish: "Halloween-Themed Treats",
        description: "Special treats combining Halloween and Día de los Muertos themes"
      }
    ]
  }
};

export default function FestivalDetail() {
  const { id } = useParams();
  const festivalId = parseInt(id || '1');
  
  // Get festival data or default to festival 1
  const festival = festivalsData[festivalId as keyof typeof festivalsData] || festivalsData[1];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": festival.title,
    "description": festival.description,
    "url": `${import.meta.env.VITE_SITE_URL}/festival-detail/${id}`,
    "startDate": festival.date,
    "location": {
      "@type": "Place",
      "name": festival.location,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Houston",
        "addressRegion": "Texas",
        "addressCountry": "US"
      }
    },
    "organizer": {
      "@type": "Organization",
      "name": "Houston Cultural Community"
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      <SEO
        title={`${festival.title} - Eric Javidi`}
        description={`${festival.description} ${festival.date} at ${festival.location}. ${festival.highlights.join(', ')}.`}
        keywords={`Houston festivals, ${festival.category} events Houston, ${festival.title}, Houston cultural events, ${festival.location}`}
        ogTitle={`${festival.title} - Eric Javidi`}
        ogDescription={festival.description}
        ogUrl={`${import.meta.env.VITE_SITE_URL}/festival-detail/${id}`}
        twitterTitle={`${festival.title} - Eric Javidi`}
        twitterDescription={festival.description}
        jsonLd={jsonLd}
      />

      {/* Navigation */}
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="text-xl font-semibold text-neutral-800">
                Eric Javidi
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-neutral-600 hover:text-green-600 px-3 py-2 text-sm font-medium">
                  Home
                </Link>
                <Link to="/about" className="text-neutral-600 hover:text-green-600 px-3 py-2 text-sm font-medium">
                  About
                </Link>
                <Link to="/guides" className="text-neutral-600 hover:text-green-600 px-3 py-2 text-sm font-medium">
                  Guides
                </Link>
                <Link to="/fall-festivals" className="text-neutral-600 hover:text-green-600 px-3 py-2 text-sm font-medium">
                  Fall Festivals
                </Link>
                <Link to="/resources" className="text-neutral-600 hover:text-green-600 px-3 py-2 text-sm font-medium">
                  Resources
                </Link>
                <Link to="/contact" className="text-neutral-600 hover:text-green-600 px-3 py-2 text-sm font-medium">
                  Contact
                </Link>
              </div>
            </div>
            <div className="md:hidden">
              <button className="text-neutral-600 hover:text-neutral-800">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Breadcrumb */}
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex items-center space-x-2 text-sm">
            <Link to="/fall-festivals" className="text-orange-600 hover:text-orange-800">Fall Festivals</Link>
            <i className="ri-arrow-right-s-line text-neutral-400"></i>
            <span className="text-neutral-600">{festival.title.split(':')[0]}</span>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-3xl lg:text-4xl font-bold text-neutral-800 mb-4">
                {festival.title}
              </h1>
              <p className="text-lg text-neutral-600 mb-8">
                {festival.description}
              </p>
              
              {/* Festival Info */}
              <div className="bg-neutral-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-neutral-800 mb-4">Festival Information</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <i className="ri-calendar-line text-orange-600 mr-2"></i>
                    <span className="text-sm text-neutral-600">{festival.date}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line text-orange-600 mr-2"></i>
                    <span className="text-sm text-neutral-600">{festival.duration}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-map-pin-line text-orange-600 mr-2"></i>
                    <span className="text-sm text-neutral-600">{festival.location}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-ticket-line text-orange-600 mr-2"></i>
                    <span className="text-sm text-neutral-600">{festival.admission}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-parking-line text-orange-600 mr-2"></i>
                    <span className="text-sm text-neutral-600">{festival.parking}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-star-line text-orange-600 mr-2"></i>
                    <span className="text-sm text-neutral-600">Best time: {festival.bestTime}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <div className="w-full h-96 bg-cover bg-center rounded-lg" style={{
                backgroundImage: `url('${festival.image}')`
              }}></div>
            </div>
          </div>
        </div>
      </section>

      {/* Festival Highlights */}
      <section className="py-12 bg-neutral-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-neutral-800 mb-8 text-center">Festival Highlights</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {festival.highlights.map((highlight, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-orange-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-neutral-800 mb-2">{highlight}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Schedule */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-neutral-800 mb-2">Festival Activities</h2>
            <p className="text-sm text-orange-600 italic">
              * Schedule and activities subject to change. Please check with event organizers for current details and exact timing.
            </p>
          </div>
          <div className="space-y-6">
            {festival.schedule.map((item, index) => (
              <div key={index} className="bg-neutral-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-neutral-800 mb-3">
                  {item.activity}
                </h3>
                <p className="text-neutral-600">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cultural Context */}
      <section className="py-12 bg-orange-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-neutral-800 mb-6">Cultural Context & History</h2>
          <div className="prose prose-lg text-neutral-700">
            <p>{festival.culturalContext}</p>
          </div>
        </div>
      </section>

      {/* Food Guide */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-neutral-800 mb-2">Food & Drink Guide</h2>
            <p className="text-sm text-orange-600 italic">
              * Food vendors and availability may vary. Check with event organizers for current vendor list.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            {festival.foodGuide.map((food, index) => (
              <div key={index} className="bg-neutral-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-neutral-800 mb-2">{food.dish}</h3>
                <p className="text-neutral-600 text-sm">{food.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Getting There */}
      <section className="py-12 bg-neutral-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-neutral-800 mb-2">Getting There</h2>
            <p className="text-sm text-orange-600 italic">
              * Please verify current location and parking information with event organizers before attending.
            </p>
          </div>
          <div className="bg-white rounded-lg overflow-hidden shadow-sm">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3463.234567890123!2d-95.4107!3d29.7821!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjnCsDQ2JzU1LjYiTiA5NcKwMjQnMzguNSJX!5e0!3m2!1sen!2sus!4v1234567890123"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={`${festival.title} Location`}
            ></iframe>
          </div>
          <div className="mt-6 grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-car-line text-orange-600"></i>
              </div>
              <h3 className="font-semibold text-neutral-800 mb-2">Driving</h3>
              <p className="text-sm text-neutral-600">{festival.parking}</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-bus-line text-blue-600"></i>
              </div>
              <h3 className="font-semibold text-neutral-800 mb-2">Public Transit</h3>
              <p className="text-sm text-neutral-600">Check METRO routes to the venue</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-taxi-line text-green-600"></i>
              </div>
              <h3 className="font-semibold text-neutral-800 mb-2">Rideshare</h3>
              <p className="text-sm text-neutral-600">Uber and Lyft available</p>
            </div>
          </div>
        </div>
      </section>

      {/* Related Festivals */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-neutral-800 mb-8">More Houston Festivals</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Link to="/festival-detail/1" className="bg-neutral-50 rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer">
              <div className="h-32 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Houston%20Mediterranean%20Festival%20with%20families%20enjoying%20traditional%20Greek%20food%2C%20colorful%20cultural%20displays%2C%20folk%20dancers%20in%20traditional%20costumes%2C%20festive%20outdoor%20celebration%20atmosphere%2C%20authentic%20Mediterranean%20culture&width=300&height=200&seq=mediterranean-related&orientation=landscape')`
              }}></div>
              <div className="p-4">
                <h3 className="font-semibold text-neutral-800 mb-1">Mediterranean Festival</h3>
                <p className="text-sm text-neutral-600">Authentic culture & cuisine</p>
              </div>
            </Link>
            
            <Link to="/festival-detail/3" className="bg-neutral-50 rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer">
              <div className="h-32 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Houston%20D%C3%ADa%20de%20los%20Muertos%20festival%20with%20colorful%20altars%2C%20families%20creating%20sugar%20skull%20art%2C%20traditional%20Mexican%20decorations%2C%20vibrant%20cultural%20celebration%2C%20marigold%20flowers%20and%20candles&width=300&height=200&seq=muertos-related&orientation=landscape')`
              }}></div>
              <div className="p-4">
                <h3 className="font-semibold text-neutral-800 mb-1">Día de los Muertos</h3>
                <p className="text-sm text-neutral-600">Life & legacy celebration</p>
              </div>
            </Link>
            
            <Link to="/fall-festivals" className="bg-orange-50 rounded-lg p-6 flex items-center justify-center text-center hover:bg-orange-100 transition-colors cursor-pointer">
              <div>
                <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-arrow-right-line text-white"></i>
                </div>
                <h3 className="font-semibold text-orange-800 mb-1">View All Festivals</h3>
                <p className="text-sm text-orange-600">Discover more celebrations</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-neutral-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-xl font-semibold mb-4">Eric Javidi</h3>
              <p className="text-neutral-300 mb-4">
                Houston-based storyteller exploring where the city's history meets its natural landscapes.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/guides" className="text-neutral-300 hover:text-white">Guides</Link></li>
                <li><Link to="/fall-festivals" className="text-neutral-300 hover:text-white">Fall Festivals</Link></li>
                <li><Link to="/resources" className="text-neutral-300 hover:text-white">Resources</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Connect</h4>
              <ul className="space-y-2">
                <li><a href="https://readdy.ai/?origin=logo" className="text-neutral-300 hover:text-white">Made with Readdy</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-neutral-700 mt-8 pt-8 text-center">
            <p className="text-neutral-400">
              © 2024 Eric Javidi. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
